<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row(v-if="!loading")
    v-col.py-0
        v-row.pa-5
            v-col
                .section__title {{ $tc("Counter._name", 1) }}
        v-row.pa-5
            v-col(cols="4")
                v-text-field(
                v-model="instance.name",
                :label="$t('Counter.name')",
                :error-messages="errors['counter.name']",
                )
            v-col(cols="4")
                v-text-field(
                v-model="value",
                :label="$t('Counter.value')",
                disabled
                )
        v-row.pa-5
            v-col(cols="12")
                v-text-field(
                v-model="instance.buildExpression",
                :label="$t('Counter.buildExpression')",
                :error-messages="errors['counter.buildExpression']",
                )
        v-row.pa-5
            v-col(cols="4")
                v-text-field(
                v-model="instance.externalId",
                :label="$t('Party.externalId')",
                disabled,
                )
            v-col(cols="4")
               app-datetime-picker(
                    :value="instance.createdAt",
                    :label="$t('Carrier.createdAt')",
                    disabled,
                    placeholder=" "
                )
            v-col(cols="4")
                app-datetime-picker(
                    :value="instance.modifiedAt",
                    :label="$t('Carrier.modifiedAt')",
                    disabled,
                    placeholder=" "
                )

</template>
<style >

.v-text-field--filled input {
  margin-top: 16px !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
    name: 'counter-add',
    mixins: [EntityMixin],
    data: () => ({ loading: true, value: ""}),
    computed: {
        uid() {
            return this.$route.params.item
        },
        errors() {
            return this.$store.state.errors;
        }
    },
    methods: {
        async load() {
            if (this.uid) {
                try {
                    this.instance = (await axios.get(`Counter/${this.uid}/`, {
                        _Entity: 'Counter',
                        uid: this.uid
                    })).data
                    this.loading = false;
                    this.instance.entityState = 3;
                } catch (error) {
                    console.error(error)
                }
            } else {
                this.loading = false;
                this.instance = {
                    businessScope: this.$store.state.user.user.businessScope,
                }
            }
        },

        async loadValue() {
          try {
              let response = (await axios.get(`counters/${this.uid}/value`, {
                  _Entity: 'Counter',
                  uid: this.uid
              })).data
              this.value = `${response.value}`;
          } catch (error) {
              console.error(error)
          }
        }

    },
    async mounted() {
        this.loadValue();
    },
    async created() {
        await this.load()
    },
}
</script>

